import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import ConfirmationModal from "commons/modal/ConfirmationModal";
import CustomModal from "commons/modal/CustomModal";
import FileNote from "pages/gant/components/mediasPages/FileNote";
import { Upload } from "@progress/kendo-react-upload";
import { completee, enAttente, enCours } from "constants/taskStatus";
import { useAddDocumentMutation, useGetDocMetaQuery, useGetTachesPlanifQuery, useGetTachesQuery, useGetTachesUsagerQuery, useUpdateTachePlanifMutation, useUpdateTacheUsagerMutation } from "../../../redux/api/cache";
import { useAppSelector } from "../../../redux/store";

function ButtonsCells(props) {
    const [confirmationDeleteModalVisible, setConfirmationDeleteModalVisible] =
        useState(false);
    const [addNoteModalVisible, setAddNoteModalVisible] =
        useState(false);
    const [updateDocumentModalVisible, setUpdateDocumentModalVisible] = useState(false);
    const [idTache, setIdTache] = useState(-1);
    const [file, setFile] = useState(undefined);
    const [addDocument] = useAddDocumentMutation();
    // @ts-ignore
    const user = useAppSelector(state => state.appState.user);
    const { data: docMeta } = useGetDocMetaQuery(props.dataItem.rid);
    const { data: task = {} } = useGetTachesQuery({ usr_cd: user, filtre: 'usager' }, { skip: !user });
    const { data: taskUser } = useGetTachesUsagerQuery({ tac_id: idTache, usr_cd: user }, { skip: idTache === -1 || !user });
    const { data: taskUsager } = useGetTachesUsagerQuery({ tac_id: idTache }, { skip: idTache === -1 });
    const { data: taskPlanif = {} } = useGetTachesPlanifQuery({ tac_id: idTache, usr_cd: '' }, { skip: idTache === -1 });
    const [updateTacheUsager] = useUpdateTacheUsagerMutation();
    const [updateTachePlanif] = useUpdateTachePlanifMutation();

    useEffect(() => {
        if (task?.data?.length > 0) {
            setIdTache(task.data.find(t => t.tac_key.includes(props.dataItem.rid)) ? task.data.find(t => t.tac_key.includes(props.dataItem.rid)).tac_id : -1);
        }
    }, [props.dataItem.rid, task]);

    const onAdd = (e) => {
        const currentFile = e.newState[0];
        const rawFile = currentFile.getRawFile();

        const reader = new FileReader();
        reader.onload = () => {
            // @ts-ignore
            rawFile.bin = reader.result.split(',')[1] ?? "";
            rawFile.Nom = props.dataItem.nom;
            rawFile.Chemin = props.dataItem.path;
            rawFile.Taille = rawFile.size;
            rawFile.saved = false;
        };

        reader.readAsDataURL(rawFile);
        setFile(rawFile);
    };

    return (<>
        <td style={{ textAlign: "right" }}>
            <a
                download={true}
                rel="noreferrer"
                className="blueButton k-icon k-font-icon k-i-search"
                target="_blank"
                href={`http://10.20.2.34/DocPublicite${process.env.REACT_APP_ENV === 'dev' ? 'Dev' : ''}/${props.dataItem.path}${props.dataItem.nom}`}
                title="Visualiser"
            >
            </a>
            <span className="blueButton k-icon k-font-icon k-i-track-changes-enable" style={{ marginLeft: "15px", cursor: "pointer" }} onClick={() => { setAddNoteModalVisible(true); }} title="Notes" />
            <span className="blueButton k-icon k-font-icon k-i-edit" style={{ marginLeft: "15px", marginRight: "15px", cursor: "pointer" }} onClick={() => { setUpdateDocumentModalVisible(true); }} title="Mettre à jour le document" />
            <span className="blueButton k-icon k-font-icon k-i-trash" style={{ marginRight: "15px", cursor: "pointer" }} onClick={async () => { setConfirmationDeleteModalVisible(!confirmationDeleteModalVisible); }} title="Supprimer le document" />
        </td>
        {addNoteModalVisible && (
            <CustomModal title="Notes" onClose={() => setAddNoteModalVisible(false)} body={
                <div style={{ margin: '0.5rem 5px' }}>
                    <div>
                        <br />
                        <FileNote
                            meta={props.dataItem}
                        ></FileNote>
                    </div>
                </div>
            } />
        )}
        {confirmationDeleteModalVisible && (
            <ConfirmationModal
                text={` Supprimer ${props.dataItem.nom} ?`}
                onClose={() => {
                    setConfirmationDeleteModalVisible(false);
                }}
                onConfirm={async () => {
                    setConfirmationDeleteModalVisible(false);
                    await props.removeFile(props.dataItem.rid);
                }}
            />
        )}
        {updateDocumentModalVisible && (
            <CustomModal title="Mettre à jour le contenu du document" onClose={() => setUpdateDocumentModalVisible(false)} buttons={[
                {
                    onClick: async () => {
                        if (file) {
                            if (!docMeta?.data?.find(d => d.docm_descr !== 'appr_req').docm_val) {
                                setUpdateDocumentModalVisible(false);
                                let document = { ...file, ...props.documentUrlParameters };
                                await addDocument({ update: 'yes', body: [document] });
                            }
                            else {
                                if (taskUser.data[0].tacusr_statut !== enCours) {
                                    window.alert("Impossible de mettre à jour le document car soit il a déjà été approuvé ou il est en attente d'approbation!");
                                } else {
                                    setUpdateDocumentModalVisible(false);
                                    let document = { ...file, ...props.documentUrlParameters };
                                    await addDocument({ update: 'yes', body: [document] });
                                    let tacheUsager = { ...taskUser.data[0], tacusr_statut: completee, tacusr_active: false };
                                    await updateTacheUsager(tacheUsager);
                                    let tasksEnAttente = taskUsager.data.filter(d => d.tacusr_statut === enAttente);
                                    tasksEnAttente.forEach(async t => { let updatedTask = { ...t, tacusr_statut: enCours }; await updateTacheUsager(updatedTask); });
                                    let taskPlanifData = structuredClone(taskPlanif.data);
                                    for (let d of taskPlanifData) {
                                        d.tacdtl_statut = completee;
                                        await updateTachePlanif(d);
                                    }
                                }
                            }
                        }
                    },
                    text: 'Sauvegarder',
                },
                {
                    onClick: () => {
                        setUpdateDocumentModalVisible(false);
                    },
                    text: 'Annuler',
                },
            ]} body={<Upload
                batch={false}
                multiple={false}
                defaultFiles={[]}
                withCredentials={false}
                autoUpload={false}
                showActionButtons={false}
                onAdd={(e) => onAdd(e)}
                onRemove={() => setFile(undefined)}
            />} />)}
    </>);
}

ButtonsCells.propTypes = {
    removeFile: PropTypes.func,
    visualizeFile: PropTypes.func,
    dataItem: PropTypes.any,
    onCreateClick: PropTypes.any,
    documentUrlParameters: PropTypes.any
};

export default React.memo(ButtonsCells);